import { Translatable } from '@icc/shared/helpers';
import { BlindBoxType } from './blind-box-type';
import { BlindSheetSetType } from './blind-sheet-set-type';
import { BlindSheetType } from './blind-sheet-type';

/** Osłona (skrzynki/blachy) */
export class Cover {
    id: string;
    /** Kod zewnętrzny */
    extId: string;
    /** Kod do indeksu */
    indexNo: string;
    @Translatable({ model: 'Profiles' })
    name: string;
    description: string;
    /**
     * Typ osłony
     *
     * * `blind_box` - skrzynka
     * * `blind_sheet` - blacha osłonowa
     * * `blind_sheet_sets` - zestaw blach osłonowych
     */
    type: 'blind_box' | 'blind_sheet' | 'blind_sheet_sets';
    /** Rozmiar [mm] */
    size: number;
    /** Wysokość [mm] */
    height: number;
    /** Głębokość konstrukcyjna [mm] */
    depth: number;
    /** Wysokość pakietu żaluzji [mm] */
    bundleHeight?: number;
    /** Maksymalna długość */
    maxLength: number;
    /** Kolejność */
    order: number;
    /** Czy dystans na izolację */
    hasIsolationDistance: boolean;
    /** Typ skrzynki */
    blindBoxTypeId: number;
    /** Typ blachy */
    blindSheetTypeId: number;
    /** Typ zestawu blach */
    blindSheetSetTypeId: number;
    /** Id grubości blachy */
    sheetThicknessId: number;
    /** Przypisane typy produktów */
    shutterTypeIds: number[];
    /** Maksymalna wysokość pakietu żaluzji */
    maxBundleHeightMM: number;
    /** Pasujące boczki */
    blindSidesIds: number[];
    /** Powiązane profile */
    associatedProfiles: {
        id: number;
        name: string;
        /** Id łącznika blach osłonowych */
        blindSheetLinkId?: number;
        blindSheetLinkName?: number;
        /** Waga */
        weight?: number;
        /** Waga stała */
        weightConst?: number;
    }[];
    /** Id zestawu grup kolorów */
    colorGroupSetId: number;
    /** Kod do wydruków */
    printCode: string;
    /** Waga */
    weight?: number;
    /** Waga stała */
    weightConst?: number;
    /** Id łącznika blach osłonowych */
    blindSheetLinkId?: number;
    blindSheetLinkName?: number;

    mountAxisDistanceMm?: number;
    requiredExternalPlasterStrip?: boolean;
}

/** Typ osłony */
export type CoverType = BlindBoxType | BlindSheetType | BlindSheetSetType;

export abstract class BaseCoverType {
    @Translatable({ model: 'BlindBoxesTypes' })
    name: string;
}